<template>
  <section class="content">
    <div>
      <b-alert variant="danger"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{messageAlert}}
    </b-alert>
    </div>
    <div class="row center-block" v-if="exibirGrafico">
      <div class="col-md-12">
        <div class="box">
          <div class="box-header" >
            <h3 class="box-title">Monitoramentos (%)</h3>
            <va-chart
                :chart-config='relatorios.producao'></va-chart>
          </div>
        </div>
      </div>
      <!-- /.box-header -->
    </div>
    <div class="row center-block">
      <div class="col-md-12" >
        <div class="box">
          <div class="box-header col-md-12">
            <h3>Requisitos de pesquisa</h3>
            <div class="form-group col-sm-12">
              <label for="dataInicioBusca" class="col-sm-2 control-label">Data Inicial</label>
              <div class="col-sm-4"> 
                <datepicker placeholder="Selecione a data inicial" v-model="dataInicioBusca" id="dataInicioBusca" :language="ptBR"></datepicker>
              </div>
              <label for="dataFimBusca" class="col-sm-2 control-label">Data Final</label>
              <div class="col-sm-4">
                <datepicker placeholder="Selecione a data final" v-model="dataFimBusca" id="dataFimBusca" :language="ptBR"></datepicker>
              </div>
            </div>
          </div>
          <!-- /.box-header -->
          <div class="box-body">
            <div class="form-group col-sm-4" >
              <div class="row">
                <label for="dados" class="col-sm-8 control-label">Tipo de Dados</label>
              </div>
              <div class="row">
                <div class="checkbox" id="dados">
                  <label>
                    <input type="checkbox" v-model="pesquisa.isDadosOperando">
                    Operando
                  </label>
                  <label>
                    <input type="checkbox" v-model="pesquisa.isDadosFuncao">
                    Função
                  </label>
                  <label>
                    <input type="checkbox" v-model="pesquisa.isDadosOutros">
                    Demais Operações
                  </label>
                  <label>
                    <input type="checkbox" v-model="pesquisa.isDadosDisponiveis">
                    Disponível
                  </label>
                </div>
              </div>
            </div>
            <div class="form-group col-sm-4" >
              <label for="maquinas" class="col-sm-2 control-label">Máquina</label>
              <select id="maquinas" class="form-control col-sm-4" v-model="pesquisa.idcontrolador">
                <option value="0">Selecione a Máquina</option>
                <option :value="monitor.idcontrolador" v-for="monitor in monitores" :key="monitor.id">{{monitor.nomemaquina}}</option>
              </select>
            </div>
            <div class="form-group col-sm-4" >
              <label for="turnos" class="col-sm-2 control-label">Turno</label>
              <select id="turnos" class="form-control col-sm-4" v-model="pesquisa.idTurnoSelecionado">
                <option value="0">Selecione o Turno</option>
                <option :value="turno.id" v-for="turno in turnos" :key="turno.id">{{turno.nometurno}}</option>
              </select>
            </div>
          </div>
          <div class="box-footer">
            <div class="col-sm-2" v>
              <button type="button" v-on:click="efetuarPesquisa()" class="btn btn-primary" v-if="pesquisa.isDadosDisponiveis || pesquisa.isDadosOperando || pesquisa.isDadosFuncao || pesquisa.isDadosOutros">
                Efetuar Pesquisa
              </button>
              <button type="button" class="btn btn-primary"  disabled v-else>
                Efetuar Pesquisa
              </button>
            </div>
          </div>
          <!-- /.box-body -->
        </div>
      </div>
    </div>  
  </section>
</template>

<script>
import VueTimepicker from 'vue2-timepicker'
import Datepicker from 'vuejs-datepicker'
import {ptBR} from 'vuejs-datepicker/dist/locale'
import VAChart from '../VAChart'
// import swal from 'sweetalert2'

export default {
  name: 'RelatoriosProducao',
  components: {
    VueTimepicker,
    Datepicker,
    'va-chart': VAChart
  },
  mounted() {
    if (window.localStorage.getItem('token')) {
      this.$store.dispatch('listMonitores')
      this.$store.dispatch('listTurnos')
    } else {
      this.showDismissibleAlert = true
      this.messageAlert = 'Favor efetuar o login para visualizar os dados'
    }
  },
  computed: {
    monitores () {
      return this.$store.state.Monitores.all
    },
    turnos () {
      return this.$store.state.Turnos.all
    },
    relatorios () {
      return this.$store.state.Relatorios
    },
    isMobile () {
      return (window.innerWidth <= 800 && window.innerHeight <= 600)
    }
  },
  data () {
    return {
      ptBR: ptBR,
      showDismissibleAlert: false,
      messageAlert: '',
      dataInicioBusca: '',
      dataFimBusca: '',
      pesquisa: {
        dataInicioBusca: '',
        dataFimBusca: '',
        idTurnoSelecionado: 0,
        idcontrolador: 0,
        isDadosOperando: true,
        isDadosFuncao: false,
        isDadosDisponiveis: false,
        isDadosOutros: false
      },
      exibirGrafico: false,
      errors: []
    }
  },
  methods: {
    track () {
      this.$ga.page('/relatoriosproducao')
    },
    efetuarPesquisa: function() {
      this.exibirGrafico = false
      if (!window.localStorage.getItem('token')) {
        this.showDismissibleAlert = true
        this.messageAlert = 'Favor efetuar o login para buscar o relatório'
      } else if ((this.dataInicioBusca === '') || (this.dataFimBusca === '')) {
        this.showDismissibleAlert = true
        this.messageAlert = 'Não pode ter data vazia'
      } else if (this.dataInicioBusca > this.dataFimBusca) {
        this.showDismissibleAlert = true
        this.messageAlert = 'Data final não pode ser anterior à data inicial'
      } else if (this.pesquisa.idcontrolador === 0) {
        this.showDismissibleAlert = true
        this.messageAlert = 'Favor selecionar uma Máquina para pesquisa'
      } else if (this.pesquisa.idTurnoSelecionado === 0) {
        this.showDismissibleAlert = true
        this.messageAlert = 'Favor selecionar um turno para pesquisa'
      } else {
        this.showDismissibleAlert = false
        this.pesquisa.dataInicioBusca = this.dataInicioBusca.toISOString().substring(0, 10)
        this.pesquisa.dataFimBusca = this.dataFimBusca.toISOString().substring(0, 10)
        this.$store.dispatch('createRelatorioProducao', this.pesquisa)
        .then(response => {
          this.exibirGrafico = true
        })
        .catch(e => {
          this.errors.push(e)
        })
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// RelatoriosProducao.vue?4786d4ce